// Wrapper component for form sections that removes bottom padding to compensate for pre-allocated error message space
import { ReactNode } from 'react';
import { SxProps } from '@mui/material';
import { SectionCard } from 'src/components/section_card';

// MUI TextField helper text uses approximately 20px of vertical space (including margins)
export const FormSectionCard = ({
  header,
  children,
  sx,
}: {
  header: ReactNode;
  children: ReactNode;
  sx?: SxProps;
}) => (
  <SectionCard header={header} sx={sx} childContainerSx={{ pb: 0 }}>
    {children}
  </SectionCard>
);
